import { SuspendedReason } from '@ecm/portfolio';

import { ButtonViewModel } from '../home/button.view-model';

export class SuspendedViewModel {
    public suspendedReason: SuspendedReason;
    public unpaid = false;
    public title: string;
    public text: string;
    public button: ButtonViewModel;
}
